export default function (other) {
  other = other || {}
  return {
    title: other.title || null,
    description: other.description || null,
    type: other.type || null,
    module: other.module || null,
    priority: other.priority || null,
    status: other.status || null,
    assignedTo: other.assignedTo || null,
    participants: other.participants || [],
  }
}
